import { getData } from '../api/axios';
import { controlData } from '../helpers/helpers';

const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.intersectionRatio > 0) {
      getData();
      observer.unobserve(entry.target);
    }
  });
});

observer.observe(controlData);
